"use client";

import { Cookie } from "lucide-react";
import { Button } from "@/app/components/ui/button";
import { useConsentStore } from "@/app/stores/consent-store";

type VideoConsentPlaceholderPropsT = {
  aspectRatio?: string;
};

/**
 * Placeholder component shown when marketing consent is not given.
 * Allows users to open the cookie preferences dialog directly.
 */
export function VideoConsentPlaceholder({
  aspectRatio = "16 / 9",
}: VideoConsentPlaceholderPropsT) {
  const { setCustomizeOpen } = useConsentStore();

  return (
    <div
      className="relative flex w-full flex-col items-center justify-center gap-4 overflow-hidden rounded-lg bg-zinc-900 p-6 text-center"
      style={{ aspectRatio }}
    >
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10">
        <div
          className="h-full w-full"
          style={{
            backgroundImage: `repeating-linear-gradient(
              45deg,
              transparent,
              transparent 10px,
              rgba(255,255,255,0.1) 10px,
              rgba(255,255,255,0.1) 20px
            )`,
          }}
        />
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center gap-4">
        <div className="max-w-sm space-y-2">
          <h3 className="heading-medium font-semibold !text-white">
            Externer Video-Inhalt
          </h3>
          <p className="text-xs leading-relaxed !text-white">
            Um dieses Video anzuzeigen, müssen Sie Marketing-Cookies
            akzeptieren. Videos von YouTube, Vimeo und anderen Plattformen
            setzen Cookies, die für Werbezwecke verwendet werden können.
          </p>
        </div>

        <Button
          variant="secondary"
          size="sm"
          className="mt-2 gap-2"
          onClick={() => setCustomizeOpen(true)}
        >
          <Cookie className="h-4 w-4" />
          Cookie-Einstellungen öffnen
        </Button>
      </div>
    </div>
  );
}
